module.exports = __webpack_public_path__ + "img/close-span.ec101f43.svg";